/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import { connect } from "react-redux";
import React, { Component } from "react";
import Input from "../../../component/input";
import Select from "../../../component/select";
import stateCode from "../../../helper/stateCode";
import { withTranslation, Trans } from "react-i18next";

import Table from "@mui/material/Table";
import Button from "@mui/material/Button";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";

import classes from "../../sales/manageCustomers/customers.module.css";
import { TableContainer } from "@mui/material";

class AddressTable extends Component {
  state = {};

  componentDidMount() {}

  //render
  render() {
    const { t } = this.props;
    return (
      <TableContainer>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell style={{ border: 0 }}>
                <Input
                  name={"attention"}
                  placeholder={t("ATTENTION" + " *")}
                  onChange={(e) => {
                    this.props.setAddress(
                      e,
                      this.props.isEdit,
                      this.props.index,
                    );
                  }}
                  value={
                    this.props.isEdit
                      ? this.props.attention
                      : this.state.attention
                  }
                />
              </TableCell>
              <TableCell style={{ border: 0 }}>
                <Input
                  name={"phone"}
                  placeholder={t("PHONE")}
                  onChange={(e) => {
                    this.props.setAddress(
                      e,
                      this.props.isEdit,
                      this.props.index,
                    );
                  }}
                  value={
                    this.props.isEdit ? this.props.phone : this.state.phone
                  }
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: 0 }}>
                <Input
                  name={"street1"}
                  placeholder={t("STREET1" + " *")}
                  onChange={(e) => {
                    this.props.setAddress(
                      e,
                      this.props.isEdit,
                      this.props.index,
                    );
                  }}
                  value={
                    this.props.isEdit ? this.props.street1 : this.state.street1
                  }
                />
              </TableCell>
              <TableCell style={{ border: 0 }}>
                <Input
                  name={"street2"}
                  placeholder={t("STREET2" + " *")}
                  onChange={(e) => {
                    this.props.setAddress(
                      e,
                      this.props.isEdit,
                      this.props.index,
                    );
                  }}
                  value={
                    this.props.isEdit ? this.props.street2 : this.state.street2
                  }
                />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: 0 }}>
                <Input
                  name={"city"}
                  placeholder={t("CITY" + " *")}
                  onChange={(e) => {
                    this.props.setAddress(
                      e,
                      this.props.isEdit,
                      this.props.index,
                    );
                  }}
                  value={this.props.isEdit ? this.props.city : this.state.city}
                />
              </TableCell>
              <TableCell style={{ border: 0 }}>
                <Input
                  name={"zip"}
                  placeholder={t("ZIP")}
                  onChange={(e) => {
                    this.props.setAddress(
                      e,
                      this.props.isEdit,
                      this.props.index,
                    );
                  }}
                  value={this.props.isEdit ? this.props.zip : this.state.zip}
                />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: 0 }}>
                <Select
                  onChange={(e) => {
                    this.props.setAddress(e);
                  }}
                  selectClass={classes.inputClass}
                  name={"country"}
                  //selected={this.props.details.shipping.country}
                  options={stateCode.country}
                  default={t("SELECT_COUNTRY")}
                  value={(a) => a.abbreviation}
                  optionLabel={(a) => a.name}
                />
              </TableCell>
              <TableCell style={{ border: 0 }}>
                <Select
                  name={"state"}
                  placeholder={"State *"}
                  onChange={(e) => {
                    this.props.setAddress(e);
                  }}
                  selectClass={classes.inputClass}
                  //selected={props.details.shipping.state}
                  options={stateCode.state[this.props.country]}
                  default={t("SELECT_STATE")}
                  value={(a) => a.abbreviation}
                  optionLabel={(a) => a.name}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: 0 }}></TableCell>
              <TableCell style={{ border: 0 }}>
                {this.props.isEdit ? (
                  <Button
                    style={{ float: "right" }}
                    onClick={() => this.props.createCustomerProfile()}
                  >
                    Update
                  </Button>
                ) : (
                  <>
                    <Button
                      style={{ float: "right" }}
                      onClick={() => this.props.createCustomerProfile()}
                    >
                      Submit
                    </Button>
                    <Button
                      style={{ float: "right" }}
                      onClick={() => this.props.hideAddressDetails()}
                    >
                      Cancel
                    </Button>
                  </>
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(AddressTable));
